import { submitFormToIam, logError } from 'actions';
import {
  ActionTypes as types,
  forms,
  paths,
  APIerrorMessages,
} from 'constants';
import { Auth } from 'utils';
import {
  resetAppErrors,
  updatePostAppError,
} from 'actions/setters/updateAppErrors';

const log = { component: 'verifyPhoneNumber' };

export default ({ values, ignoreFormActions = false, push }) => dispatch => {
  const userGuid = Auth.getUserGuid();
  const userResource = `/users/${userGuid}/phonenumber/${values.PhoneNumber}/confirm-code/${values.VerificationCode}`;
  const body = {
    userGuid,
    PhoneNumber: values.PhoneNumber,
    VerificationCode: values.VerificationCode,
  };

  const onFetching = () => {
    dispatch({
      type: types.VERIFY_PHONE,
      payload: values.PhoneNumber,
    });
  };

  const onSuccess = () => {
    dispatch({
      type: types.UPDATE_USER,
      payload: body,
    });
    dispatch({
      type: types.VERIFY_PHONE_SUCCESS,
    });
    push(paths.Personal);
    dispatch(resetAppErrors());
  };

  const onError = error => {
    if (
      error !== APIerrorMessages.tooManyRequests ||
      error !== APIerrorMessages.wrongCode
    ) {
      dispatch(logError(types.UPDATE_APP_STATUS_POST_ERROR, { ...log, error }));
    }
    dispatch(updatePostAppError(error));
  };

  return dispatch(
    submitFormToIam(forms.VerifyPhone, userResource, userGuid, body, {
      clearForm: false,
      onSuccess,
      onFetching,
      onError,
      ignoreFormActions,
    }),
  );
};
